<template>
    <div class="animated fadeIn unearnsettlefrm">        
        <b-card>
            <div slot="header">
                {{this.$route.meta.title}}
                <div class="card-header-actions">
                  <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
                <b-col lg="10" class="settlement-data">
                  <b-row>
                      <b-col lg="6" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Type Adjusment</label></b-input-group-prepend>
                            <b-form-radio-group
                              id="radio-group-1"
                              v-model="model.typeadjs"
                              :options="typesusoptions"
                              name="radio-options"
                              class="mt-2"
                            ></b-form-radio-group>
                        </b-input-group>   
                      </b-col>
                  </b-row>
                  <b-row>
                      <b-col lg="6" class="settlement-data">
                          <b-input-group >
                              <b-input-group-prepend><label>{{typeadjstext}} Date</label></b-input-group-prepend>
                              <b-form-input v-model="model.tglsettl" type="date" :state="!$v.model.tglsettl.$error"></b-form-input>                                        
                          </b-input-group>
                      </b-col>
                      <b-col lg="6" class="settlement-data">
                          <b-input-group >
                              <b-input-group-prepend><label>Prepaid {{typeadjstext}} No.</label></b-input-group-prepend>
                              <b-form-input v-model="model.settleno" readonly></b-form-input>
                          </b-input-group>  
                      </b-col>
                  </b-row> 
                  <b-row>
                      <b-col lg="6" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Agreement No.</label></b-input-group-prepend>
                            <b-form-input v-model="model.no_agreement" readonly :state="!$v.model.pinjamankey.$error"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuPinjamanPrepaidShow=true">
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>   
                      </b-col>
                      <b-col lg="6" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Application No.</label></b-input-group-prepend>
                            <b-form-input v-model="model.no_kontrak" readonly></b-form-input>
                        </b-input-group>   
                      </b-col>
                  </b-row>
                  <b-row>
                      <b-col lg="6" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Debitur Name</label></b-input-group-prepend>
                            <b-form-input v-model="model.CustName" readonly></b-form-input>
                        </b-input-group>   
                      </b-col>
                      <b-col lg="6" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Debitur No. (CIF)</label></b-input-group-prepend>
                            <b-form-input v-model="model.CustCode" readonly></b-form-input>
                        </b-input-group>   
                      </b-col>
                  </b-row>
                  <b-row>
                      <b-col lg="6" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Tenor.</label></b-input-group-prepend>
                            <b-form-input v-model="model.tenor" readonly></b-form-input>
                        </b-input-group>   
                      </b-col>
                      <b-col lg="6" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Go Live - Maturity Date</label></b-input-group-prepend>
                            <b-form-input class="form-control-plaintext" readonly v-model="model.loanperiod"></b-form-input>
                        </b-input-group>   
                      </b-col>
                  </b-row>
                  <b-row>
                      <b-col lg="6" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Prepaid</label></b-input-group-prepend>
                            <my-number class="form-control text-right" separator="," v-model="model.totalpbb" :precision="2" disabled></my-number>
                        </b-input-group>   
                      </b-col>
                  </b-row>
                  
                  <b-row>
                      <b-col lg="6" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Prepaid {{typeadjstext}}</label></b-input-group-prepend>
                            <my-number class="form-control text-right" separator="," v-model="model.settleamt" :precision="2"></my-number>
                        </b-input-group>   
                      </b-col>
                  </b-row>
                  <b-row>
                      <b-col lg="8" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                            <b-form-textarea
                                  id="textarea"
                                  v-model="model.settleuraian"
                                  placeholder="Enter Description"
                                  rows="3"
                                  max-rows="6"
                                ></b-form-textarea>                          </b-input-group>   
                      </b-col>
                  </b-row>
                   <b-row>
                      <b-col lg="8" class="settlement-data">
                        <b-input-group >
                            <b-input-group-prepend><label>Adjust. Account</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.glAccount"  :state="!$v.model.kodeacc.$error"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuCoaShow=true">
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                      </b-col>
                  </b-row>

                   
                  <b-row>
                      <b-col lg="8" class="settlement-data">
                        <div style="text-align: right">
                            <b-button variant="success" @click="refund()" :disabled="!saveEnabled">
                              <i class="fa fa-exchange"></i> {{typeadjstext}}</b-button
                            >
                        </div>  
                      </b-col>
                  </b-row>
                </b-col>
            </b-row>       
        </b-card>
        <b-modal v-model="lkuPinjamanPrepaidShow" size="lg" :hide-footer="true" title="List of Loan Prepaid" :centered="true">
            <lku-pinjamanprepaid @click="onSelectLkuPjmnPrepaid" :formdata="lkuPjmnPrepaidData" :selectedrow="lkuPjmnPrepaidSelected"></lku-pinjamanprepaid>
        </b-modal>          
        <b-modal
          v-model="lkuCoaShow"
          size="lg"
          :hide-footer="true"
          title="List of GL Account"
          :centered="true"
        >
          <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>
      <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

    </div>
</template>
<style lang="scss">
    .settlement-data .input-group .input-group-prepend label {
        padding-top: 5px;
        padding-right: 5px;
        width: 197px !important;
    }
    .input-group-prepend {
        label {
            padding-top: 5px;
            padding-right: 5px;
            width: 150px !important;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 120px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { validationMixin } from "vuelidate";
import { required, requiredIf, requiredUnless, minValue, minLength, numeric } from "vuelidate/lib/validators";

import myNumber from "../../components/my-number";

import lkuPinjamanprepaid from "../lookup/lkuPinjamanPrepaid";
import lkuCoa from "../lookup/lkuCoa";

import arsettlement from '../../apis/arsettlement';
import arpbbadjust from '../../apis/fin_arpbbadjust';
import produkkredit from '../../apis/produkkredit';

toastr.init();

export default {   
  components: { Loading,myNumber, lkuPinjamanprepaid, lkuCoa},
  mixins: [validationMixin],
  validations: {
        model: {
            pinjamankey: { required },
            settleuraian: { required },
            tglsettl: { required },
            settleamt: { required, minValue:minValue(0.01) },
            totalpbb: { required, minValue:minValue(0.00000001) },
            kodeacc: { required }        
        },
        arpaymdtObj :{
            pinjamankey: { required },
            nilaisettl_desc: { required },
            nilaisettl: {
              minValue: function () {
                if (this.adaPotongan) {
                  return true;
                } else if ((this.arpaymdtObj.nilaisettl || 0) < 0.01) {
                  return false;
                } else return true;
              },
            },
            nilaibank: {
              minValue: function () {
                if (this.adaPotongan) {
                  return true;
                } else if ((this.arpaymdtObj.nilaibank || 0) < 0) {
                  return false;
                } else return true;
              },
            },
            nilaidiskon: {
              required: function () {
                if ((this.arpaymdtObj.nilaibank || 0) > 0.01) {
                  return true;
                } else if ((this.arpaymdtObj.nilaidiskon || 0) < 0) {
                  return false;
                } else return true;
              },
            },
            kurssettle: { required:false, 
            // minValue: minValue(0.0000001)
            },
            kodecash: {
              required: function () {
                // if ((this.arpaymdtObj.nilaibank || 0) == 0) {
                //   return true;
                // } else if ((this.arpaymdtObj.kodecash || "") == "") {
                //   return false;
                // } else 
                return true;
              },
            },
        },
  }, 
  data() {
    return {
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        isLoading:false,
        arGroups : [],
        currency:[{value:'IDR',text:'IDR'}],
        potongans:[],
        saveEnabled:true,
        inputBerlanjut: 0,
        inputLineBerlanjut: 1,
        model:{settleno:'',arpaymKey:'',totalpbb:0,paym_group:'',
        tglsettl:moment().format('YYYY-MM-DD'),settleamt:0, 
        kurstrx:1, settleuraian:'', custcode:'', customer_id:'',
        loanperiod:'',kodeacc:'',typeadjs:'refund'},
        typeadjstext:'Refund',
        pbb:{},
        lblExchRate:"Exch. Rate ",
        bankOnly:1,
        totalDtlPaym:0,
        unsttlpbb: 0,
        updateDimHdr:false,
        updateDimDtl:true,
        arpaymdt: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "loaninfo",
                    thStyle: "width:150px",
                    label: "No Loan | Installment No. ",
                    sortable: true
                },
                {
                    key: "nilaisettl_desc",
                    label: "Jenis Settlement",
                    thStyle: "width:150px",
                    sortable: true
                },
                {
                    key: "tgl_jttempo",
                    label: "Tgl Jth. Tempo",
                    thStyle: "width:100px",
                    sortable: true
                },
                
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "CCY",
                    sortable: true
                },
                {
                    key: "nilaibyr",
                    label: "Nilai Settlement",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                // {
                //     key: "kurskeAR",
                //     label: "Exch.Rate to Original",
                //     thStyle: "width:100px",
                //     thClass: "text-right",
                //     tdClass: "text-right"
                // },
                {
                    key: "nilaibank",
                    label: "Settlement Prepaid",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kasdiskon",
                    label: "Settlement Discount",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:120px",
                    sortable: true
                }
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        arpaymdtObj:{arinvKey:'',
         kodecash:'',
          IDPotongan:'',
         kasdiskon:0,
         nilaibank:0,
         nilaisettl:0,
         nilaibyr:0},
        lkuCustomerShow:false,
        lkuInstallmentShow:false,
        lkuCashflowShow:false,
        lkuCoaShow: false,
        lkuInstallmentData:{},
        lkuInstallmentFilterData:{},
        lkuInstallmentSelected:[],
        lkuArinvShow: false,
        lkuArInvData:{},
        lkuPinjamanPrepaidShow:false,
        lkuPjmnPrepaidData:{ 
          isrrd:true       
        },
        lkuPjmnPrepaidSelected:[],
        tabIndex:0,
        typesusoptions: [
          { text: 'Refund', value: 'refund' },
          { text: 'Alloc. To Other Inc.', value: 'allocationtootherincome' }
        ]

    };
},
  computed: {
    uanguser(){
      return this.$store.state.user.matauang;
    },
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidArpaymdt() {
      this.$v.arpaymdtObj.$touch();
      return this.$v.arpaymdtObj.$invalid;
    },
    adaPotongan(){
        return ((this.arpaymdtObj.kasdiskon || 0) != 0);
    },
    IDPotongan(){return this.arpaymdtObj.IDPotongan;},
    adaNilaiBank(){return ((this.arpaymdtObj.nilaibank || 0) != 0);},
  },
  watch: {
    IDPotongan: function(kode) {
        let pot = this.potongans.find(r => r.value===kode);
        if (pot){
            this.arpaymdtObj.Potongan=pot.text;
        }
    },   
    "arpaymdtObj.nilaisettl_desc": function (newVal) {
      const pbbos = this.model.totalpbb;
      switch (newVal) {
        case "BUNGA":

          this.arpaymdtObj.nilaisettl = pbbos < this.arpaymdtObj.outstand_bunga ?pbbos:this.arpaymdtObj.outstand_bunga;
          this.arpaymdtObj.nilaibank = pbbos < this.arpaymdtObj.outstand_bunga ? pbbos:this.arpaymdtObj.outstand_bunga;
          break;

        case "DENDA":
          this.arpaymdtObj.nilaisettl = pbbos < this.arpaymdtObj.outstand_denda ? pbbos:this.arpaymdtObj.outstand_denda;
          this.arpaymdtObj.nilaibank = pbbos < this.arpaymdtObj.outstand_denda ? pbbos:this.arpaymdtObj.outstand_denda;
          break;

        default:
          this.arpaymdtObj.nilaisettl = pbbos < this.arpaymdtObj.outstand_pokok ? pbbos:this.arpaymdtObj.outstand_pokok;
          this.arpaymdtObj.nilaibank = pbbos < this.arpaymdtObj.outstand_pokok ? pbbos:this.arpaymdtObj.outstand_pokok;
          break;
      }
    },
    "model.totalbyr": function (newVal) {
      this.model.totaldiskon = newVal - this.model.totalbank;
      this.model.totaldiskon =
        this.model.totaldiskon < 0 ? 0 : this.model.totaldiskon;
    },
    "model.totalbank": function (newVal) {
      this.model.totaldiskon = this.model.totalbyr - newVal;
      this.model.totaldiskon =
        this.model.totaldiskon < 0 ? 0 : this.model.totaldiskon;
    }, 
    "model.typeadjs":function(val){
      this.typeadjstext = (this.typesusoptions.find(x=>x.value == val)).text||'';
    }
  },
  created: async function(){
      this.model.matauang=this.uanguser;
      this.model.tglsettl = moment().format('YYYY-MM-DD');

      if (this.$route.params.settleKey) {
          toastr.info('Loading Payment Detail, please wait')
          try {
            const [a,data] = await Promise.all([
              arpbbadjust.currency(),
              await arpbbadjust.detail(this.$route.params)
            ]) ;
            this.currency = a;
            const row = data[0][0];

            this.saveEnabled=(row.posting === 0 || row.send2wf ===0 );
            for (var key in row) {
                this.pbb[key] = row[key];
            }
            this.pbb.tglpaym = row.tglpaym ? moment(row.tglpaym).format('YYYY-MM-DD') : '';
            this.model.custcode = this.pbb.custcode;
            this.model.customer_id = this.pbb.customer_id;
            this.model.settleno = row.settleno;
            this.model.matauang = row.matauang;
            this.model.no_agreement=row.no_agreement;
            this.model.CustName = row.CustName;
            this.model.tenor = row.tenor;
            this.model.no_kontrak = row.no_kontrak;
            this.model.CustCode = row.CustCode;
             this.model.settleuraian=row.settleuraian;
             this.model.loanperiod = `${moment(row.startdate).format('DD/MM/YYYY')} - ${moment(row.duedate).format('DD/MM/YYYY')}`;
            this.model.glAccount = row.kodeacc.trim() + ' | ' + row.namaacc.trim();
            this.model.kodeacc = row.kodeacc;
            this.model.namaacc = row.namaacc;
            this.model.totalpbb=row.totalpbb;
            this.unsttlpbb= this.model.totalpbb;
            this.model.arpaymKey=row.arpaymKey;
            this.model.settleamt=row.settleamt;
            this.model.arpaymKey=row.arpaymKey;
            this.model.tglsettl = (row.tglsettl) ? moment(row.tglsettl).format('YYYY-MM-DD') : '';

            
            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
        const [a,c,d] = await Promise.all([arpbbadjust.currency(),await arpbbadjust.argroup(),await arpbbadjust.potongan()]) ;
        this.currency = a;
        this.arGroups = c;
        this.potongans = d;
      }
  },
  methods: {
    showLkuCashflow(callerObj) {
      this.lkuCashflowShow = true;
      this.lkuCashflowCaller = callerObj;
    },
    onSelectLkuPjmnPrepaid: async function (arsetData) {
        console.log('arsetData',arsetData);
        this.lkuPjmnPrepaidSelected=[];
        this.lkuPjmnPrepaidSelected.push(arsetData.selected.pinjamankey)
        const {selected} = arsetData;
        this.model.loanperiod = `${moment(selected.startdate).format('DD/MM/YYYY')} - ${moment(selected.duedate).format('DD/MM/YYYY')}`
        this.model.custcode = selected.custcode;
        this.model.nasabahkey = selected.nasabahkey;
        this.model.settleamt = selected.pbb_ost
        this.model.totalpbb=selected.pbb_ost;
        this.model.pinjamankey = selected.pinjamankey;
        this.model.no_agreement = selected.no_agreement;
        this.model.no_kontrak = selected.no_kontrak;
        this.model.CustName = selected.CustName;
        this.model.CustCode = selected.CustCode;
        this.model.tenor = selected.tenor;
        this.model.settleuraian = `${this.typeadjstext} Prepaid - ${selected.no_agreement_no_point} - ${selected.CustName}`;
        this.model.paym_group =selected.wo_status==1?'WO':'NM';
        this.lkuPjmnPrepaidData=arsetData;
        this.lkuInstallmentFilterData.nasabahkey = arsetData.selected.customer_id;

        const detailProd = await produkkredit.detail(selected.productkey);
        if(this.model.typeadjs ==='refund'){
          this.model.glAccount = detailProd.Refund_Account_No.trim() + ' | ' + detailProd.Refund_Account_Nm.trim();
          this.model.kodeacc = detailProd.Refund_Account_No.trim();
          this.model.namaacc = detailProd.Refund_Account_Nm.trim();
        }else{
          this.model.glAccount = detailProd.OTH_INCOME_No.trim() + ' | ' + detailProd.OTH_INCOME_Nm.trim();
          this.model.kodeacc = detailProd.OTH_INCOME_No.trim();
          this.model.namaacc = detailProd.OTH_INCOME_Nm.trim();
        }
        

        this.lkuPinjamanPrepaidShow=false;

    },
    onSelectLkuCashflow(_selected) {
      // this.model.cashflow =
      //   _selected.kodecash.trim() + " | " + _selected.namacash.trim();
      // this.model.kodeacc = _selected.kodecash;
      // this.model.namaacc = _selected.namacash;
      // this.lkuCashflowShow = false;
    },
    onSelectLkuCoa(_selected) {
        this.model.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.model.kodeacc = _selected.kodeacc;
        this.model.namaacc = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;            
        const opened= this.arpaymdt.items.find( r=> r._showDetails==true);
        if (opened) {
            toastr.warn('Detail Form Un Saved');
            this.saveEnabled=true;
            return;
        }
        this.model.settleamt=this.totalDtlPaym;
        this.model.kurstrx = this.pbb.kurstrx;
        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else if (this.totalDtlPaym > parseFloat(this.model.totalpbb)) {
            toastr.error('[Total Detail Settlement] is greater than [Unearned Inc. BALANCE]', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else {
            try {
            // this.model.TableName = 'arsttltt';
            //     const dimValResult = await dimension.validate(this.model);
            //     if (dimValResult.success) {
                    this.model.settleno = this.model.settleno || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.custcodeb4=this.pbb.custcode;
                    row.customer_idb4=this.pbb.customer_id;
                    row.tglsettl = moment(row.tglsettl).format('YYYY-MM-DD');
                    let settl_amt=0;
                    let newArpaymdts = this.arpaymdt.items.reduce((newArr, item) => {
                        if ((item.angsurankey || '') != '' || (item.pinjamankey || '') != '') {
                            // item.kurspost = this.model.kurstrx;
                            settl_amt += item.nilaibank;
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);
                    row.settleamt=settl_amt;

                    row.arpaymdt = newArpaymdts;
                    const hasil= await arsettlement.save(row);
                    toastr.success(`Success, Trx.Number ${hasil.settleno}`, "Save PBB Settlement",10000);
                    if (this.inputBerlanjut==0){
                        this.close();
                    } else {
                        this.saveEnabled=true;            
                        // const jenis = this.model.jenis;
                        for (var key in this.model) {
                            this.model[key] = '';
                        }
                        // this.model.jenis = jenis;
                        // this.model.matauang= this.$store.state.user.matauang;
                        this.model.tglsettl = moment().format('YYYY-MM-DD');
                        this.arpaymdt.items = [];
                        this.arpaymdt.total=0;
                        this.calcTotalDtlPaym();
                        this.$v.model.$reset();
                    }


                // } else {
                //     console.log('dimValResult : ', dimValResult);
                //     var msg = dimValResult.message || 'Dimension validation error';
                //     toastr.error(msg, "ERROR MESSAGE");
                // }
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;            
            }

        }
    },
    closeArPayment: function(){
        const opened= this.arpaymdt.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    updateNilaibank: function () {
      if (this.model.matauang == this.arpaymdtObj.matauang) {
        this.arpaymdtObj.nilaibank =
          this.arpaymdtObj.nilaisettl - (this.arpaymdtObj.nilaidiskon || 0);
      }
    },
    saveArpaymdt: function (callback) {
        if (!this.adaPotongan) this.arpaymdtObj.IDPotongan='';
        this.arpaymdtObj.nilaibyr = this.arpaymdtObj.nilaibyr || 0;
        this.arpaymdtObj.kasdiskon = this.arpaymdtObj.kasdiskon || 0;
                
        if (this.invalidArpaymdt) {
            console.log('validation : ', this.$v.arpaymdtObj);
            console.log('model obj : ',this.arpaymdtObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            let totInvSttl = this.arpaymdt.items.reduce((tot, item) => {
                            if (item.arinvKey == this.arpaymdtObj.arinvKey) {
                                tot + ((item.nilaibyr||0)+(item.kasdiskon||0));
                            }
                            return tot;
                        }, (this.arpaymdtObj.nilaibyr + this.arpaymdtObj.kasdiskon));
            if (this.arpaymdt.selected.arinvKey == this.arpaymdtObj.arinvKey)
                totInvSttl= totInvSttl -  ((this.arpaymdt.selected.nilaibyr||0) + (this.arpaymdt.selected.kasdiskon||0));

            // if ((this.arpaymdtObj.nilaibyr + this.arpaymdtObj.kasdiskon)>this.arpaymdtObj.outstand){
            // if (totInvSttl>this.arpaymdtObj.outstand){
            if ((totInvSttl-this.arpaymdtObj.outstand) > 0.01) {
                toastr.error('Settled Amount exceeds Outstanding Amount', "ERROR MESSAGE");
            } else {
                this.arpaymdtObj.selisihkurs = this.arpaymdtObj.nilaibank - (this.arpaymdtObj.nilaibyr * this.arpaymdtObj.kurskeAR);
                for (var key in this.arpaymdtObj) {
                    this.arpaymdt.selected[key] = this.arpaymdtObj[key];
                }
                this.calcTotalDtlPaym();
                this.arpaymdt.selected._showDetails=false;
                if (callback) callback();
                if (this.inputLineBerlanjut==1) {
                    this.addArpaymdt();
                    this.$v.arpaymdtObj.$reset();
                }
            }
       }
    },
    onSelectLkuArinv(invLookup) {
        this.arpaymdtObj.arinvKey=invLookup.selected.arinvKey;
        this.arpaymdtObj.invoiceno=invLookup.selected.invoiceno;
        this.arpaymdtObj.uraian=invLookup.selected.uraian;
        this.arpaymdtObj.matauang=invLookup.selected.matauang;
        this.arpaymdtObj.totalinv=invLookup.selected.totalinv;
        this.arpaymdtObj.outstand=invLookup.selected.outstand;
        if (invLookup.selected.outstand<(this.unsttlpbb - this.totalDtlPaym)) {
            this.arpaymdtObj.nilaibyr=invLookup.selected.outstand;
        } else {
            this.arpaymdtObj.nilaibyr=(this.unsttlpbb - this.totalDtlPaym);
        }
        this.arpaymdtObj.cashflow=invLookup.selected.cashflow;
        this.arpaymdtObj.kodecash=invLookup.selected.kodecash;
        this.arpaymdtObj.nilaidpp=invLookup.selected.nilaidpp;
        this.arpaymdtObj.ttlpph=invLookup.selected.ttlpph;
        this.arpaymdtObj.pasalpph=invLookup.selected.pasalpph;
        this.updateDimDtl2Hdr(invLookup.selected);
        if (this.arpaymdtObj.matauang.trim() == this.model.matauang.trim()) {
            this.arpaymdtObj.nilaibank=this.arpaymdtObj.nilaibyr;
            this.arpaymdtObj.kurskeAR = 1;
            this.arpaymdtObj.selisihkurs = 0;
        }
        this.lkuArinvShow=false;
        this.lkuArInvData=invLookup;
        arsettlement.byrsemu(invLookup.selected).then(result => {
                this.arpaymdtObj.byr_semu= result.byr_semu;
                this.arpaymdtObj.byr_semu_doc= result.byr_semu_doc;
            })
            .catch(err => {
                console.log('byrsemu -> ', err);
            });
    },
    onSelectLkuInstallment(data){
        // if(this.lkuInstallmentSelected.includes(data.selected.angsurankey)){
        //     toastr.info('Data sudah ada dalam list.', "INFO MESSAGE",10000);
        //     return;
        // }
        // this.lkuInstallmentSelected.push(data.selected.angsurankey);
        this.arpaymdtObj.tgl_jttempo = data.selected.tgl_jttempo;
        this.arpaymdtObj.CustName = data.selected.CustName;
        this.arpaymdtObj.no_kontrak =`${data.selected.no_kontrak}${data.selected.angsuran_ke?' | '+data.selected.angsuran_ke:''}`
        this.arpaymdtObj.angsurankey=data.selected.angsurankey;
        this.arpaymdtObj.pinjamankey=data.selected.pinjamankey;
        this.arpaymdtObj.arinvKey=data.selected.arinvKey;
        // this.arpaymdtObj.invoiceno=data.selected.invoiceno;
        this.arpaymdtObj.loaninfo=`${data.selected.no_kontrak}${data.selected.angsuran_ke?' | '+data.selected.angsuran_ke:''}`;
        this.arpaymdtObj.uraian=data.selected.uraian;
        this.arpaymdtObj.matauang=data.selected.matauang;
        this.arpaymdtObj.outstand_pokok =data.selected.outstand_pokok>0.009?data.selected.outstand_pokok:0; 
        this.arpaymdtObj.outstand_denda =data.selected.outstand_denda>0.009?data.selected.outstand_denda:0; 
        this.arpaymdtObj.outstand_bunga =data.selected.outstand_bunga>0.009?data.selected.outstand_bunga:0; 

        const totalinv = (data.selected.outstand_bunga||0)+(data.selected.outstand_denda||0)+(data.selected.outstand_pokok||0);
        data.selected.outstand = totalinv;
        this.arpaymdtObj.totalinv=totalinv;
        this.arpaymdtObj.outstand=totalinv;
        if (data.selected.outstand<(this.unsttlpbb - this.totalDtlPaym)) {
            this.arpaymdtObj.nilaibyr=data.selected.outstand;
        } else {
            this.arpaymdtObj.nilaibyr=(this.unsttlpbb - this.totalDtlPaym);
        }
        this.arpaymdtObj.cashflow=data.selected.cashflow;
        this.arpaymdtObj.kodecash=data.selected.kodecash;
        this.arpaymdtObj.nilaidpp=data.selected.nilaidpp;
        this.arpaymdtObj.ttlpph=data.selected.ttlpph;
        this.arpaymdtObj.pasalpph=data.selected.pasalpph;
        this.updateDimDtl2Hdr(data.selected);
        if ((this.arpaymdtObj.matauang||this.$store.state.user.matauang).trim() == this.model.matauang.trim()) {
            this.arpaymdtObj.nilaibank=this.arpaymdtObj.nilaibyr;
            this.arpaymdtObj.kurskeAR = 1;
            this.arpaymdtObj.selisihkurs = 0;
        }
        this.lkuInstallmentData=data;
        // arsettlement.byrsemu(data.selected).then(result => {
        //         this.arpaymdtObj.byr_semu= result.byr_semu;
        //         this.arpaymdtObj.byr_semu_doc= result.byr_semu_doc;
        //     })
        //     .catch(err => {
        //         console.log('byrsemu -> ', err);
        //     });
        this.lkuInstallmentShow=false;
    },
    calcPotongan : function() {
        let pot = this.potongans.find(r => r.value=== this.arpaymdtObj.IDPotongan);
        if (pot){
            if (pot.pajak) {
                this.arpaymdtObj.kasdiskon = this.arpaymdtObj.nilaidpp * this.arpaymdtObj.tarif / 100;
            } else {
                this.arpaymdtObj.kasdiskon = this.arpaymdtObj.totalinv * this.arpaymdtObj.tarif / 100;
            }
        } else {
            this.arpaymdtObj.kasdiskon = this.arpaymdtObj.totalinv * this.arpaymdtObj.tarif / 100;
        }
    },

    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.othPayment.obj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtlPaym: function () {
        let totalDtlPaym = this.model.bcharge || 0;
        totalDtlPaym = totalDtlPaym || 0;
        this.arpaymdt.items.forEach( function (trx) {
            console.log('trx',trx);
            if (trx.angsurankey|| trx.pinjamankey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaibank);
        });
        this.totalDtlPaym = totalDtlPaym;
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name!=='receivable.pbbsettlefrm'))  {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'loan.pbbsettle'});
      }
    },
    async refund(){
      if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
      }else{
        try{
          this.isLoading = true;
          const hasil = await arpbbadjust.save(this.model);
          toastr.success(`Success, Trx. Number ${hasil.settleno}`, "Save Prepaid Adjustment",10000);
          this.isLoading = false;
          router.push({name:'loan.prepaidadjusment'});
        } catch (error) {
          this.isLoading = false;
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }   
              this.saveEnabled=true;            
        }
      } 
        
    }
  }
};
</script>
